import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AdminReportsDataListItemCollection = ({ item }) => (
  <td className="collection">
    <Link to={`/collections/${item.uuid}`} target="_blank" style={{ marginLeft: (item.level || 0) * 20 }}>
      {item.name}
    </Link>
  </td>
);

AdminReportsDataListItemCollection.propTypes = {
  item: PropTypes.object.isRequired,
};

export default AdminReportsDataListItemCollection;
